<ng-container>
  <!--begin::Sidebar Brand-->
  <div class="sidebar-brand">
    <!--begin::Brand Link-->
    <a routerLink="/app" class="brand-link">
      <!--begin::Brand Image-->
      <img [src]="logoUrl" alt="Gateway3 Logo" class="brand-image shadow" />
    </a>
    <!--end::Brand Link-->
  </div>
  <!--end::Sidebar Brand-->
  <!--begin::Sidebar Wrapper-->
  <div class="sidebar-wrapper">
    <nav class="mt-2">
      <!--begin::Sidebar Menu-->
      <ul class="nav sidebar-menu flex-column" data-lte-toggle="treeview" role="menu" data-accordion="false"
        style="width: 100%; box-sizing: border-box;">
        @for (section of menuSections; track section) {
          @if (isSectionVisible(section)) {
            <li class="nav-header"
              [ngClass]="{'active': isActiveSectionHeader(section.header)}">
              {{ section.header }}
            </li>
          }
          @for (item of section.items; track item) {
            @if (isItemVisible(item)) {
              <li class="nav-item"
                [ngClass]="{'menu-open': item.dropdownKey && isDropdownOpen(item.dropdownKey)}">
                @if (!item.children) {
                  <a [routerLink]="getRouterLink(item)" class="nav-link"
                    [class.active]="isLinkActive(item)">
                    <i class="nav-icon" [ngClass]="item.icon"></i>
                    <p>{{ item.label }}</p>
                  </a>
                }
                @if (item.children) {
                  <div class="nav-link d-flex align-items-center justify-content-between"
                    (click)="toggleDropdown(item.dropdownKey, $event)"
                    [attr.aria-expanded]="isDropdownOpen(item.dropdownKey)" style="cursor: pointer;">
                    <span class="d-flex">
                      <i class="nav-icon" [ngClass]="item.icon"></i>
                      <p class="d-inline mb-0">{{ item.label }}</p>
                    </span>
                    <i class="bi"
                      [ngClass]="isDropdownOpen(item.dropdownKey) ? 'bi-chevron-up' : 'bi-chevron-down'"
                    style="transition: transform 0.2s;"></i>
                  </div>
                }
                @if (item.children) {
                  <ul class="nav nav-treeview ps-4"
                    [hidden]="!isDropdownOpen(item.dropdownKey)">
                    @for (child of item.children; track child) {
                      @if (isItemTreeVisible(child)) {
                        <li class="nav-item"
                          [ngClass]="{'menu-open': child.dropdownKey && isDropdownOpen(child.dropdownKey)}">
                          @if (!child.children) {
                            <a [routerLink]="getRouterLink(child)" class="nav-link"
                              [class.active]="isLinkActive(child)">
                              <i class="nav-icon" [ngClass]="child.icon"></i>
                              <p>{{ child.label }}</p>
                            </a>
                          }
                          @if (child.children) {
                            <div class="nav-link d-flex align-items-center justify-content-between"
                              (click)="toggleDropdown(child.dropdownKey, $event)"
                              [attr.aria-expanded]="isDropdownOpen(child.dropdownKey)" style="cursor: pointer;">
                              <span class="d-flex">
                                <i class="nav-icon" [ngClass]="child.icon"></i>
                                <p class="d-inline mb-0">{{ child.label }}</p>
                              </span>
                              <i class="bi"
                                [ngClass]="isDropdownOpen(child.dropdownKey) ? 'bi-chevron-up' : 'bi-chevron-down'"
                              style="transition: transform 0.2s;"></i>
                            </div>
                          }
                          @if (child.children) {
                            <ul class="nav nav-treeview ps-4"
                              [hidden]="!isDropdownOpen(child.dropdownKey)">
                              @for (grandChild of child.children; track grandChild) {
                                @if (isItemVisible(grandChild)) {
                                  <li class="nav-item">
                                    <a [routerLink]="getRouterLink(grandChild)" class="nav-link"
                                      [class.active]="isLinkActive(grandChild)">
                                      <i class="nav-icon" [ngClass]="grandChild.icon"></i>
                                      <p>{{ grandChild.label }}</p>
                                    </a>
                                  </li>
                                }
                              }
                            </ul>
                          }
                        </li>
                      }
                    }
                  </ul>
                }
              </li>
            }
          }
        }
      </ul>
      <!--end::Sidebar Menu-->
    </nav>
  </div>
  <!--end::Sidebar Wrapper-->
</ng-container>